import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import VueJwtDecode from "vue-jwt-decode";
import VueSweetalert2 from "vue-sweetalert2";
import excel from "vue-excel-export";
import moment from "vue-moment";

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(VueJwtDecode);
Vue.use(VueSweetalert2);
Vue.use(excel);
Vue.use(moment);

import "sweetalert2/dist/sweetalert2.min.css";

new Vue({
  router,
  store,
  Vuetify,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
